import React from "react";
import { Link } from "react-router-dom";
import "./Legal.scss";

const CookiesPolicy = () => {
    return (
        <div className="legal-page">
            <div className="legal-page__container">
                <header className="legal-page__header">
                    <p className="legal-page__eyebrow">Techadive Policies</p>

                    <h1>
                        Cookies <span>Policy.</span>
                    </h1>

                    <p className="legal-page__updated">
                        Last updated: <time dateTime="2025-10-30">October 30, 2025</time>
                    </p>
                </header>

                <article
                    className="legal-page__content"
                    aria-label="Cookies policy"
                >
                    <section aria-labelledby="cookies-definition">
                        <h2 id="cookies-definition">1. What Are Cookies?</h2>
                        <p>
                            Cookies are small text files stored on your device when you
                            visit a website. They help us improve your browsing experience
                            by remembering your preferences and understanding how you
                            interact with our site.
                        </p>
                    </section>

                    <section aria-labelledby="cookies-use">
                        <h2 id="cookies-use">2. How We Use Cookies</h2>
                        <ul>
                            <li>
                                <strong>Essential Cookies:</strong> Required for the
                                website to function properly.
                            </li>
                            <li>
                                <strong>Analytics Cookies:</strong> Help us understand how
                                visitors use our website.
                            </li>
                            <li>
                                <strong>Functional Cookies:</strong> Remember user
                                preferences and improve usability.
                            </li>
                        </ul>
                    </section>

                    <section aria-labelledby="cookies-management">
                        <h2 id="cookies-management">3. Managing Cookies</h2>
                        <p>
                            You can control or delete cookies through your browser
                            settings. Most browsers allow you to block or delete cookies,
                            though some site features may not function properly without
                            them.
                        </p>
                    </section>

                    <section aria-labelledby="cookies-third-parties">
                        <h2 id="cookies-third-parties">4. Third-Party Services</h2>
                        <p>
                            We may use third-party tools such as Google Analytics, which
                            may set their own cookies. These tools help us monitor website
                            performance and improve user experience.
                        </p>
                    </section>

                    <section aria-labelledby="cookies-changes">
                        <h2 id="cookies-changes">5. Changes to This Policy</h2>
                        <p>
                            We may update this Cookies Policy occasionally to reflect
                            changes in technology or regulations.
                        </p>
                    </section>
                </article>

                <nav className="legal-page__links" aria-label="Related pages">
                    <Link to="/privacy-policy">Privacy Policy</Link>
                    <Link to="/contact">
                        Contact Techadive
                        <span aria-hidden="true">↗</span>
                    </Link>
                </nav>
            </div>
        </div>
    );
};

export default CookiesPolicy;